import { SEARCH_TAGS, USER_TAGS_LIST } from "../actions/tagsAction";
import {
  SET_ITEMS_PER_PAGE,
  CHANGE_CURRENT_PAGE,
  LOADING,
} from "../actions/userAction";

const initialState = {
  userTags: [],
  userSearchText: "",
  totalResults: null,
  currentPage: 1,
  resultsPerPage: 10,
  totalPages: null,
  pageIds: [],
  fetchingData: true,
};

const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_TAGS_LIST: {
      return {
        ...state,
        userTags: action.payload,
        fetchingData: false,
      };
    }
      case SEARCH_TAGS: {
         return {
           ...state,
           userSearchTags: action.payload,
         };
       }

    case SET_ITEMS_PER_PAGE: {
      return {
        ...state,
        resultsPerPage: action.payload,
      };
    }
     
    case CHANGE_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }
    case LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }


    default:
      return state;
  }
};

export default tagsReducer;
